import styled from "styled-components"

const ModalFooter = styled.div`
  padding-top: 35px;
  padding-left: 25px;
  padding-right: 25px;
  text-align: center;

  button + button {
    margin-left: 7px;
  }
`

export default ModalFooter
